/** Accounts created by `python manage.py bulk_seeder`. */
export const DEMO_ACCOUNTS = [
  {
    username: 'candidate',
    password: 'Candidate@123',
    label: 'Candidate',
    hint: 'Interview practice',
  },
  {
    username: 'consultancy',
    password: 'Consultancy@123',
    label: 'Consultancy',
    hint: 'Talent CRM',
  },
  {
    username: 'student',
    password: 'Student@123',
    label: 'Candidate (college)',
    hint: 'Same account as a candidate',
  },
  {
    username: 'placement',
    password: 'Placement@123',
    label: 'Placement head',
    hint: 'Demo University',
  },
  {
    username: 'training',
    password: 'Training@123',
    label: 'Training head',
    hint: 'Demo School',
  },
  {
    username: 'institution',
    password: 'Institution@123',
    label: 'Institution',
    hint: 'Harbor Institute',
  },
  {
    username: 'partner',
    password: 'Partner@123',
    label: 'EdTech partner',
    hint: 'Tutorial catalog',
  },
];

/** Extra seeded logins (not on the public login chip strip). */
export const DEMO_EXTRA_ACCOUNTS = [
  {
    username: 'candidate2',
    password: 'Candidate@123',
    label: 'Candidate 2',
    hint: 'Second candidate pool',
  },
  {
    username: 'consultancy2',
    password: 'Consultancy@123',
    label: 'Consultancy 2',
    hint: 'Second firm CRM',
  },
];

export const DEMO_ADMIN = {
  username: 'admin',
  password: 'Admin@123',
  label: 'Super admin',
  hint: 'Full access',
};

export const DEMO_SALES = {
  username: 'sales',
  password: 'Sales@123',
  label: 'Sales (limited)',
  hint: 'Partner wallets + inquiries · ₹2/click',
};

/** Flow checklists for Test Manager (consultancy / institution / partner). */
export const TEST_FLOW_GUIDES = [
  {
    id: 'consultancy',
    title: 'Consultancy flow',
    account: 'consultancy / Consultancy@123',
    summary: 'Talent CRM, companies, invites, unlocks, scheduling.',
    links: [
      { to: '/crm', label: 'CRM' },
      { to: '/candidate-management', label: 'Candidates' },
      { to: '/client-companies', label: 'Client companies' },
      { to: '/talent-discovery', label: 'Talent discovery' },
      { to: '/business-intelligence', label: 'BI' },
      { to: '/consultancy-ops', label: 'Ops' },
      { to: '/subscription-billing', label: 'Billing' },
    ],
    steps: [
      'Log in as consultancy and open CRM pipeline.',
      'Open Candidates — own pool loads; additional profiles gated by talent pack.',
      'Add/rate a candidate or open an existing profile.',
      'Open Client companies — rate company or attach skill tutorials.',
      'Schedule a screening interview from a candidate card.',
      'Confirm talent discovery / BI pages load without empty-shell errors.',
    ],
  },
  {
    id: 'institution',
    title: 'Institution flow',
    account: 'institution / Institution@123 (also placement, training)',
    summary: 'Learners, INR plans, training interviews, reports.',
    links: [
      { to: '/institution/learners', label: 'Learners' },
      { to: '/institution/plans', label: 'Plans' },
      { to: '/institution/interviews', label: 'Interviews' },
      { to: '/institution/reports', label: 'Reports' },
      { to: '/profile', label: 'Profile' },
    ],
    steps: [
      'Log in as institution (Harbor) or placement/training campus head.',
      'Open Learners — campus roster from OrganizationMembership.',
      'Open Plans — INR per-candidate packs visible.',
      'Schedule or open a training interview for a learner.',
      'Open a shared report for a completed session.',
    ],
  },
  {
    id: 'partner',
    title: 'EdTech partner flow',
    account: 'partner / Partner@123',
    summary: 'Tutorials, skill/domain tags, CPC wallet, public partners page.',
    links: [
      { to: '/partner/dashboard', label: 'Partner dashboard' },
      { to: '/partners', label: 'Public partners' },
      { to: '/tutorials', label: 'Tutorials' },
      { to: '/admin/partners', label: 'Admin partners (as admin)' },
      { to: '/admin/sales', label: 'Admin sales (as admin/sales)' },
    ],
    steps: [
      'Log in as partner — dashboard lists SkillForge tutorials.',
      'Create or edit a tutorial with skill and domain tags.',
      'As admin: approve partner / tutorial and fund CPC wallet if needed.',
      'Open public /partners — listing appears when funded + approved.',
      'As candidate, open a weak-topic suggestion or partners page and confirm click analytics.',
    ],
  },
];
